/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unused-prop-types */
import React, { useState, useEffect, useCallback, useRef } from 'react'
import PropTypes from 'prop-types'

import { Button, Input, InputLabel, MenuItem, Select } from '@mui/material'
import { SearchOutlined } from '@mui/icons-material'
import Container, { RightWrapper, LeftWrapper } from './styles'

const ManualAnalysisSearchBar = (props) => {
  const { setSearchParams } = props
  const [searchText, setSearchText] = useState('')
  const [decision, setDecision] = useState('ALL')
  const isFirstRender = useRef(true)
  
  
  const handleOnChangeCPF = event => {
    setSearchText(event.target.value)
  }
  
  const handleSubmitSearch = useCallback(() => {
    const parsedDecisions = {
      ALL: undefined,
      WAITING_CLARIFICATION: "WAITING_DECISION",
    }
    const searchParams = {
      candidate_cpf: searchText !== '' ? searchText : undefined,
      decision: decision in parsedDecisions ? parsedDecisions[decision] : decision,
      waiting_clarification: decision === "WAITING_CLARIFICATION" ? true : undefined,
    }
    setSearchParams(searchParams)
  }, [searchText, decision])
  
  const handleChangeStatus = (event) => {
    const { value } = event.target
    
    setDecision(value)
  }

  const handleEnter = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault()
      handleSubmitSearch()
    }
    return false
  }
  
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }
    if (searchText === "")
      handleSubmitSearch()
  }, [searchText, handleSubmitSearch])

  const buildStatusFilter = () => (
    <div className="status-filter">
    <InputLabel id="status">Filtrar por status:</InputLabel>
    <Select
      labelId="status"
      id="status "
      value={decision}
      onChange={handleChangeStatus}
      autoWidth
      variant="standard"
    >
      <MenuItem
        style={{
          fontSize: '1.25rem',
        }}
        value="ALL"
      >
        Todos
      </MenuItem>
      <MenuItem
        style={{
          fontSize: '1.25rem',
        }}
        value="WAITING_DECISION"
      >
        Aguardando Revisão
      </MenuItem>

      <MenuItem
        style={{
          fontSize: '1.25rem',
        }}
        value="WAITING_CLARIFICATION"
      >
        Aguardando Esclarecimentos
      </MenuItem>
      
      
      <MenuItem
        style={{
          fontSize: '1.25rem',
        }}
        value="APPROVED"
      >
        Aprovados
      </MenuItem>
      <MenuItem
        style={{
          fontSize: '1.25rem',
        }}
        value="REPROVED"
      >
        Reprovados
      </MenuItem>
      <MenuItem
        style={{
          fontSize: '1.25rem',
        }}
        value="SUSPENDED"
      >
        Suspensos
      </MenuItem>
    </Select>
  </div>
  )

  
  return (
    <Container>
      <LeftWrapper>
        <Input type='search' placeholder='Digite o CPF do candidato' value={searchText} onChange={handleOnChangeCPF} onKeyUp={handleEnter} />
        <Button onClick={handleSubmitSearch}> 
          <SearchOutlined /> 
        </Button>
      </LeftWrapper>
      <RightWrapper>
        {buildStatusFilter()}
      </RightWrapper>
    </Container>
  )
}

ManualAnalysisSearchBar.propTypes = {
  setSearchParams: PropTypes.func.isRequired,
}

export default ManualAnalysisSearchBar
